import React from 'react';
import { LoanApprovalDataProvider } from './LoanApprovalDataProvider';
import LoanOfficerView from './LoanOfficerView';

interface LoanOfficerViewWithProviderProps {
  data?: any;
  formikProps?: any;
  onSubmit?: (values: any) => void;
}

/**
 * LoanOfficerViewWithProvider - Wrapper component that provides loan balance data
 * to LoanOfficerView through the LoanApprovalDataProvider context.
 * 
 * This component should be used in approval workflows instead of LoanOfficerView directly.
 */
const LoanOfficerViewWithProvider: React.FC<LoanOfficerViewWithProviderProps> = (props) => {
  return (
    <LoanApprovalDataProvider
      valueData={props.formikProps?.values?.valueData || props.data?.valueData}
      data={props.data}
      formikProps={props.formikProps}
    >
      <LoanOfficerView {...props} />
    </LoanApprovalDataProvider>
  );
};

export default LoanOfficerViewWithProvider;
